/**
 * Landing preference vs. the Home tab (vendor#1409, PR #1419 fix round).
 *
 * Shell: (desktop). Pure.
 *
 * `defaultLandingPath` is where the app OPENS: arriving at `/` cold, from a
 * bookmark or the home-screen icon, redirects there. The phone's Home tab is a
 * different act — the owner ruled "Home opens the dashboard" — so it navigates
 * to `/` carrying {@link DASHBOARD_STATE}, and `DesktopIndex` renders the
 * dashboard for that navigation instead of redirecting. Without it, a dealer
 * whose landing page is Search would tap Home and land on Search with the
 * Search tab lit, and on a phone the dashboard would be unreachable.
 *
 * Router state, not a query param: it is never in a URL, so it cannot be
 * bookmarked or shared. It DOES survive a reload of that history entry
 * (React Router keeps it in `history.state`), so reloading the dashboard the
 * Home tab opened shows the dashboard again — which is what was asked for. A
 * fresh open of `/` (new tab, bookmark, home-screen icon) carries no state and
 * follows the preference.
 */

/** Pass as `navigate('/', { state: DASHBOARD_STATE })` to open the dashboard itself. */
export const DASHBOARD_STATE = { dashboard: true } as const;

function asksForDashboard(state: unknown): boolean {
  return (
    typeof state === 'object' && state !== null && 'dashboard' in state && state.dashboard === true
  );
}

/**
 * Where `/` should redirect, or null to render the dashboard.
 * The landing preference applies on a cold open only.
 */
export function landingRedirect(landing: string | null | undefined, state: unknown): string | null {
  if (asksForDashboard(state)) return null;
  if (landing && landing !== '/') return landing;
  return null;
}
